import { render } from "./touchspinIconButton.vue?vue&type=template&id=6eea52a2"
import script from "./touchspinIconButton.vue?vue&type=script&lang=js"
export * from "./touchspinIconButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__